export class Formatters {
  static formatPhoneNumber(phoneNumber: string | undefined): string {
    if (phoneNumber) {
      if (phoneNumber.length == 10) {
        return (
          phoneNumber.substring(0, 3) +
          '-' +
          phoneNumber.substring(3, 6) +
          '-' +
          phoneNumber.substring(6, 10)
        );
      } else {
        return phoneNumber;
      }
    }
    return '';
  }
}
